import React from "react";

import Chart from "../../components/charts";
// import LineChart from "../../components/lineChart";
import { AddMember } from "../../components/buttons/addMember";
import AddProduct from "../../components/buttons/addProduct";
import { useHistory } from "react-router-dom";
import Additional from "../../components/ingredients";
import "./styles.scss";
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import stringJp from '../../constants/stringJP';
import useWindowDimensions from "../../components/useWindowDemision";
import { Modal } from 'antd';

export default function ChartPage() {
    let history = useHistory();
    const [open, setOpen] = React.useState(true);
    const [isload, setIsLoad] = React.useState(false);
    const {width, height } = useWindowDimensions();
    const url = new URL(window.location.href);
    const paramsUrl = url.searchParams;
    const account_id = paramsUrl.get("account_id");
    localStorage.setItem("account_id", account_id);
    const security_key = paramsUrl.get("security_key");
    localStorage.setItem("security_key", security_key);
    const company_code = paramsUrl.get("company_code");
    localStorage.setItem("company_code", company_code);
    const store_code = paramsUrl.get("store_code");
    localStorage.setItem("store_code", store_code);
    const instore_code = paramsUrl.get("instore_code");
    localStorage.setItem("instore_code", instore_code);
    const area_code = paramsUrl.get("area_code");
    localStorage.setItem("area_code", area_code);
    const timerange_code = paramsUrl.get("timerange_code");
    localStorage.setItem("timerange_code", timerange_code);
    const purchase_flag = paramsUrl.get("purchase_flag");
    localStorage.setItem("purchase_flag", purchase_flag);
    const cart_flag = paramsUrl.get("cart_flag");
    localStorage.setItem("cart_flag", cart_flag);
    const add_flag = paramsUrl.get("add_flag");
    localStorage.setItem("add_flag", add_flag);

    const dataChart = JSON.parse(localStorage.getItem("dataChart"));
    const recommendList = JSON.parse(localStorage.getItem("recommendList"));


    setTimeout(() => {
        setOpen(false);
    }, 3000);

    const styleBodyText={
        width:210,
        height:50,
        marginLeft:-width/4,
        marginTop:height/6.5,
        justifyContent:'center', 
        alignItems:'center', 
        display: 'flex',
    };
    // const title_recommend={
    //     textAlign: "center",
    //     fontSize: 18,
    //     paddingTop: 23,
    //     paddingBottom: 10,
    //     fontWeight: 700,
    // };
    const styleText={
        fontSize: 25, 
        fontWeight: 'bold', 
        fontStyle:'Roboto', 
        color:'#FFFFFF'
    };

    const modalErr =()=>{

        return (
            <Collapse in={open}>
                <Alert
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                > {stringJp.label_alert_product} </Alert>
            </Collapse> 
        );
    };

    const ingredient=()=>{
        return(
            <div className="additional">
                <Additional
                    account_id={account_id}
                    company_code={company_code}
                    store_code={store_code}
                    instore_code={instore_code}
                    dataChart={dataChart}
                    security_key={security_key}
                    area_code={area_code}
                    timerange_code={timerange_code}
                    recommendList={recommendList}
                    cart_flag={cart_flag}
                    add_flag={add_flag}
                />
            </div>
        );
    };

    const handleClickAddPrd =()=> history.push('/add-product');

    return (
        <>
            <div className="chart_page" style={{ minHeight: height }}>
                <div>
                    <Chart
                        account_id={account_id}
                        company_code={company_code}
                        store_code={store_code}
                        instore_code={instore_code}
                        security_key={security_key}
                        setIsLoad={setIsLoad}
                        purchase_flag={purchase_flag?.toString() === 'false'}
                    /> 
                    {/* <LineChart/> */}

                    <AddMember account_id={account_id} />
                    
                    <AddProduct handleClickAddPrd ={handleClickAddPrd}/> 

                    {/* <h3 style={title_recommend}> {stringJp.label_title_recommend}</h3> */}

                    { isload === false ? "" 
                        : isload === true && dataChart?.length === 0 ? modalErr() 
                        :ingredient()
                    }
                </div>
            </div>

            <Modal
                bodyStyle={{padding:0, width:0, height:0}}
                width={0}
                closable={false}
                visible={purchase_flag?.toString() === 'false'}
                footer={null}
                mask={true}
                maskStyle={{backgroundColor:' rgba(0, 0, 0, 0.35)'}}>
                <div style={styleBodyText}>
                    <p style={styleText}> Coming soon...</p>
                </div>
            </Modal>
        </>
    );
}
